import { initializeApp, getApps, getApp } from 'firebase/app';
import {
  getAuth,
  onAuthStateChanged,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
  signOut,
  User,
} from 'firebase/auth';

let firebaseApp;
let auth;

class FirebaseAuthBackend {
  constructor(firebaseConfig: object) {
    if (firebaseConfig) {
      // Reuse an already-initialised default app instead of calling
      // initializeApp twice (the e2e bootstrap creates + emulator-connects the
      // app first; in prod this is simply the first initialisation). Avoids a
      // duplicate-app init and lets the Auth emulator connection apply before
      // this backend's listener triggers any account lookup.
      firebaseApp = getApps().length ? getApp() : initializeApp(firebaseConfig);
      auth = getAuth(firebaseApp);

      onAuthStateChanged(auth, (user) => {
        if (user) {
          sessionStorage.setItem('authUser', JSON.stringify(user));
        } else {
          sessionStorage.removeItem('authUser');
        }
      });
    }
  }

  registerUser = (user: { email: string; password: string }): Promise<User> => {
    return createUserWithEmailAndPassword(auth, user.email, user.password).then((cred) => cred.user);
  };

  loginUser = (email: string, password: string): Promise<User> => {
    return signInWithEmailAndPassword(auth, email, password).then((cred) => cred.user);
  };

  forgetPassword = (email: string): Promise<void> => {
    return sendPasswordResetEmail(auth, email, {
      url: `${window.location.protocol}//${window.location.host}/login`,
    });
  };

//   logout = (): Promise<void> => {
//     return signOut(getAuth());
//   };

  setLoggeedInUser = (user: User) => {
    sessionStorage.setItem('authUser', JSON.stringify(user));
  };

  getAuthenticatedUser = (): User | null => {
    return auth.currentUser;
  };

  _handleError(error: any) {
    return error.message;
  }
}

let _fireBaseBackend: FirebaseAuthBackend | null = null;

const initFirebaseBackend = (config: object) => {
  if (!_fireBaseBackend) {
    _fireBaseBackend = new FirebaseAuthBackend(config);
  }
  return _fireBaseBackend;
};

const getFirebaseBackend = () => _fireBaseBackend;

export { initFirebaseBackend, getFirebaseBackend };
